// source: https://github.com/stefangabos/world_countries
export const countries = {
  hu: {
    '4': {
      id: 4,
      alpha2: 'af',
      alpha3: 'afg',
      name: 'Afganisztán',
    },
    '8': {
      id: 8,
      alpha2: 'al',
      alpha3: 'alb',
      name: 'Albánia',
    },
    '12': {
      id: 12,
      alpha2: 'dz',
      alpha3: 'dza',
      name: 'Algéria',
    },
    '20': {
      id: 20,
      alpha2: 'ad',
      alpha3: 'and',
      name: 'Andorra',
    },
    '24': {
      id: 24,
      alpha2: 'ao',
      alpha3: 'ago',
      name: 'Angola',
    },
    '28': {
      id: 28,
      alpha2: 'ag',
      alpha3: 'atg',
      name: 'Antigua és Barbuda',
    },
    '31': {
      id: 31,
      alpha2: 'az',
      alpha3: 'aze',
      name: 'Azerbajdzsán',
    },
    '32': {
      id: 32,
      alpha2: 'ar',
      alpha3: 'arg',
      name: 'Argentína',
    },
    '36': {
      id: 36,
      alpha2: 'au',
      alpha3: 'aus',
      name: 'Ausztrália',
    },
    '40': {
      id: 40,
      alpha2: 'at',
      alpha3: 'aut',
      name: 'Ausztria',
    },
    '44': {
      id: 44,
      alpha2: 'bs',
      alpha3: 'bhs',
      name: 'Bahama-szigetek',
    },
    '48': {
      id: 48,
      alpha2: 'bh',
      alpha3: 'bhr',
      name: 'Bahrein',
    },
    '50': {
      id: 50,
      alpha2: 'bd',
      alpha3: 'bgd',
      name: 'Banglades',
    },
    '51': {
      id: 51,
      alpha2: 'am',
      alpha3: 'arm',
      name: 'Örményország',
    },
    '52': {
      id: 52,
      alpha2: 'bb',
      alpha3: 'brb',
      name: 'Barbados',
    },
    '56': {
      id: 56,
      alpha2: 'be',
      alpha3: 'bel',
      name: 'Belgium',
    },
    '64': {
      id: 64,
      alpha2: 'bt',
      alpha3: 'btn',
      name: 'Bhután',
    },
    '68': {
      id: 68,
      alpha2: 'bo',
      alpha3: 'bol',
      name: 'Bolívia',
    },
    '70': {
      id: 70,
      alpha2: 'ba',
      alpha3: 'bih',
      name: 'Bosznia-Hercegovina',
    },
    '72': {
      id: 72,
      alpha2: 'bw',
      alpha3: 'bwa',
      name: 'Botswana',
    },
    '76': {
      id: 76,
      alpha2: 'br',
      alpha3: 'bra',
      name: 'Brazília',
    },
    '84': {
      id: 84,
      alpha2: 'bz',
      alpha3: 'blz',
      name: 'Belize',
    },
    '90': {
      id: 90,
      alpha2: 'sb',
      alpha3: 'slb',
      name: 'Salamon-szigetek',
    },
    '96': {
      id: 96,
      alpha2: 'bn',
      alpha3: 'brn',
      name: 'Brunei',
    },
    '100': {
      id: 100,
      alpha2: 'bg',
      alpha3: 'bgr',
      name: 'Bulgária',
    },
    '104': {
      id: 104,
      alpha2: 'mm',
      alpha3: 'mmr',
      name: 'Mianmar',
    },
    '108': {
      id: 108,
      alpha2: 'bi',
      alpha3: 'bdi',
      name: 'Burundi',
    },
    '112': {
      id: 112,
      alpha2: 'by',
      alpha3: 'blr',
      name: 'Fehéroroszország',
    },
    '116': {
      id: 116,
      alpha2: 'kh',
      alpha3: 'khm',
      name: 'Kambodzsa',
    },
    '120': {
      id: 120,
      alpha2: 'cm',
      alpha3: 'cmr',
      name: 'Kamerun',
    },
    '124': {
      id: 124,
      alpha2: 'ca',
      alpha3: 'can',
      name: 'Kanada',
    },
    '132': {
      id: 132,
      alpha2: 'cv',
      alpha3: 'cpv',
      name: 'Zöld-foki Köztársaság',
    },
    '140': {
      id: 140,
      alpha2: 'cf',
      alpha3: 'caf',
      name: 'Közép-Afrika',
    },
    '144': {
      id: 144,
      alpha2: 'lk',
      alpha3: 'lka',
      name: 'Srí Lanka',
    },
    '148': {
      id: 148,
      alpha2: 'td',
      alpha3: 'tcd',
      name: 'Csád',
    },
    '152': {
      id: 152,
      alpha2: 'cl',
      alpha3: 'chl',
      name: 'Chile',
    },
    '156': {
      id: 156,
      alpha2: 'cn',
      alpha3: 'chn',
      name: 'Kína',
    },
    '170': {
      id: 170,
      alpha2: 'co',
      alpha3: 'col',
      name: 'Kolumbia',
    },
    '174': {
      id: 174,
      alpha2: 'km',
      alpha3: 'com',
      name: 'Comore-szigetek',
    },
    '178': {
      id: 178,
      alpha2: 'cg',
      alpha3: 'cog',
      name: 'Kongói Köztársaság (Kongó)',
    },
    '180': {
      id: 180,
      alpha2: 'cd',
      alpha3: 'cod',
      name: 'Kongói Demokratikus Köztársaság (Zaire)',
    },
    '188': {
      id: 188,
      alpha2: 'cr',
      alpha3: 'cri',
      name: 'Costa Rica',
    },
    '191': {
      id: 191,
      alpha2: 'hr',
      alpha3: 'hrv',
      name: 'Horvátország',
    },
    '192': {
      id: 192,
      alpha2: 'cu',
      alpha3: 'cub',
      name: 'Kuba',
    },
    '196': {
      id: 196,
      alpha2: 'cy',
      alpha3: 'cyp',
      name: 'Ciprus',
    },
    '203': {
      id: 203,
      alpha2: 'cz',
      alpha3: 'cze',
      name: 'Csehország',
    },
    '204': {
      id: 204,
      alpha2: 'bj',
      alpha3: 'ben',
      name: 'Benin',
    },
    '208': {
      id: 208,
      alpha2: 'dk',
      alpha3: 'dnk',
      name: 'Dánia',
    },
    '212': {
      id: 212,
      alpha2: 'dm',
      alpha3: 'dma',
      name: 'Dominikai Közösség',
    },
    '214': {
      id: 214,
      alpha2: 'do',
      alpha3: 'dom',
      name: 'Dominikai Köztársaság',
    },
    '218': {
      id: 218,
      alpha2: 'ec',
      alpha3: 'ecu',
      name: 'Ecuador',
    },
    '222': {
      id: 222,
      alpha2: 'sv',
      alpha3: 'slv',
      name: 'Salvador',
    },
    '226': {
      id: 226,
      alpha2: 'gq',
      alpha3: 'gnq',
      name: 'Egyenlítői-Guinea',
    },
    '231': {
      id: 231,
      alpha2: 'et',
      alpha3: 'eth',
      name: 'Etiópia',
    },
    '232': {
      id: 232,
      alpha2: 'er',
      alpha3: 'eri',
      name: 'Eritrea',
    },
    '233': {
      id: 233,
      alpha2: 'ee',
      alpha3: 'est',
      name: 'Észtország',
    },
    '242': {
      id: 242,
      alpha2: 'fj',
      alpha3: 'fji',
      name: 'Fidzsi',
    },
    '246': {
      id: 246,
      alpha2: 'fi',
      alpha3: 'fin',
      name: 'Finnország',
    },
    '250': {
      id: 250,
      alpha2: 'fr',
      alpha3: 'fra',
      name: 'Franciaország',
    },
    '262': {
      id: 262,
      alpha2: 'dj',
      alpha3: 'dji',
      name: 'Dzsibuti',
    },
    '266': {
      id: 266,
      alpha2: 'ga',
      alpha3: 'gab',
      name: 'Gabon',
    },
    '268': {
      id: 268,
      alpha2: 'ge',
      alpha3: 'geo',
      name: 'Grúzia',
    },
    '270': {
      id: 270,
      alpha2: 'gm',
      alpha3: 'gmb',
      name: 'Gambia',
    },
    '276': {
      id: 276,
      alpha2: 'de',
      alpha3: 'deu',
      name: 'Németország',
    },
    '288': {
      id: 288,
      alpha2: 'gh',
      alpha3: 'gha',
      name: 'Ghána',
    },
    '296': {
      id: 296,
      alpha2: 'ki',
      alpha3: 'kir',
      name: 'Kiribati',
    },
    '300': {
      id: 300,
      alpha2: 'gr',
      alpha3: 'grc',
      name: 'Görögország',
    },
    '308': {
      id: 308,
      alpha2: 'gd',
      alpha3: 'grd',
      name: 'Grenada',
    },
    '320': {
      id: 320,
      alpha2: 'gt',
      alpha3: 'gtm',
      name: 'Guatemala',
    },
    '324': {
      id: 324,
      alpha2: 'gn',
      alpha3: 'gin',
      name: 'Guinea',
    },
    '328': {
      id: 328,
      alpha2: 'gy',
      alpha3: 'guy',
      name: 'Guyana',
    },
    '332': {
      id: 332,
      alpha2: 'ht',
      alpha3: 'hti',
      name: 'Haiti',
    },
    '340': {
      id: 340,
      alpha2: 'hn',
      alpha3: 'hnd',
      name: 'Honduras',
    },
    '348': {
      id: 348,
      alpha2: 'hu',
      alpha3: 'hun',
      name: 'Magyarország',
    },
    '352': {
      id: 352,
      alpha2: 'is',
      alpha3: 'isl',
      name: 'Izland',
    },
    '356': {
      id: 356,
      alpha2: 'in',
      alpha3: 'ind',
      name: 'India',
    },
    '360': {
      id: 360,
      alpha2: 'id',
      alpha3: 'idn',
      name: 'Indonézia',
    },
    '364': {
      id: 364,
      alpha2: 'ir',
      alpha3: 'irn',
      name: 'Irán',
    },
    '368': {
      id: 368,
      alpha2: 'iq',
      alpha3: 'irq',
      name: 'Irak',
    },
    '372': {
      id: 372,
      alpha2: 'ie',
      alpha3: 'irl',
      name: 'Írország',
    },
    '376': {
      id: 376,
      alpha2: 'il',
      alpha3: 'isr',
      name: 'Izrael',
    },
    '380': {
      id: 380,
      alpha2: 'it',
      alpha3: 'ita',
      name: 'Olaszország',
    },
    '384': {
      id: 384,
      alpha2: 'ci',
      alpha3: 'civ',
      name: 'Elefántcsontpart',
    },
    '388': {
      id: 388,
      alpha2: 'jm',
      alpha3: 'jam',
      name: 'Jamaica',
    },
    '392': {
      id: 392,
      alpha2: 'jp',
      alpha3: 'jpn',
      name: 'Japán',
    },
    '398': {
      id: 398,
      alpha2: 'kz',
      alpha3: 'kaz',
      name: 'Kazahsztán',
    },
    '400': {
      id: 400,
      alpha2: 'jo',
      alpha3: 'jor',
      name: 'Jordánia',
    },
    '404': {
      id: 404,
      alpha2: 'ke',
      alpha3: 'ken',
      name: 'Kenya',
    },
    '408': {
      id: 408,
      alpha2: 'kp',
      alpha3: 'prk',
      name: 'Észak-Korea (Koreai NDK)',
    },
    '410': {
      id: 410,
      alpha2: 'kr',
      alpha3: 'kor',
      name: 'Dél-Korea (Koreai Köztársaság)',
    },
    '414': {
      id: 414,
      alpha2: 'kw',
      alpha3: 'kwt',
      name: 'Kuvait',
    },
    '417': {
      id: 417,
      alpha2: 'kg',
      alpha3: 'kgz',
      name: 'Kirgizisztán',
    },
    '418': {
      id: 418,
      alpha2: 'la',
      alpha3: 'lao',
      name: 'Laosz',
    },
    '422': {
      id: 422,
      alpha2: 'lb',
      alpha3: 'lbn',
      name: 'Libanon',
    },
    '426': {
      id: 426,
      alpha2: 'ls',
      alpha3: 'lso',
      name: 'Lesotho',
    },
    '428': {
      id: 428,
      alpha2: 'lv',
      alpha3: 'lva',
      name: 'Lettország',
    },
    '430': {
      id: 430,
      alpha2: 'lr',
      alpha3: 'lbr',
      name: 'Libéria',
    },
    '434': {
      id: 434,
      alpha2: 'ly',
      alpha3: 'lby',
      name: 'Líbia',
    },
    '438': {
      id: 438,
      alpha2: 'li',
      alpha3: 'lie',
      name: 'Liechtenstein',
    },
    '440': {
      id: 440,
      alpha2: 'lt',
      alpha3: 'ltu',
      name: 'Litvánia',
    },
    '442': {
      id: 442,
      alpha2: 'lu',
      alpha3: 'lux',
      name: 'Luxemburg',
    },
    '450': {
      id: 450,
      alpha2: 'mg',
      alpha3: 'mdg',
      name: 'Madagaszkár',
    },
    '454': {
      id: 454,
      alpha2: 'mw',
      alpha3: 'mwi',
      name: 'Malawi',
    },
    '458': {
      id: 458,
      alpha2: 'my',
      alpha3: 'mys',
      name: 'Malajzia',
    },
    '462': {
      id: 462,
      alpha2: 'mv',
      alpha3: 'mdv',
      name: 'Maldív-szigetek',
    },
    '466': {
      id: 466,
      alpha2: 'ml',
      alpha3: 'mli',
      name: 'Mali',
    },
    '470': {
      id: 470,
      alpha2: 'mt',
      alpha3: 'mlt',
      name: 'Málta',
    },
    '478': {
      id: 478,
      alpha2: 'mr',
      alpha3: 'mrt',
      name: 'Mauritánia',
    },
    '480': {
      id: 480,
      alpha2: 'mu',
      alpha3: 'mus',
      name: 'Mauritius',
    },
    '484': {
      id: 484,
      alpha2: 'mx',
      alpha3: 'mex',
      name: 'Mexikó',
    },
    '492': {
      id: 492,
      alpha2: 'mc',
      alpha3: 'mco',
      name: 'Monaco',
    },
    '496': {
      id: 496,
      alpha2: 'mn',
      alpha3: 'mng',
      name: 'Mongólia',
    },
    '498': {
      id: 498,
      alpha2: 'md',
      alpha3: 'mda',
      name: 'Moldova',
    },
    '499': {
      id: 499,
      alpha2: 'me',
      alpha3: 'mne',
      name: 'Montenegró',
    },
    '504': {
      id: 504,
      alpha2: 'ma',
      alpha3: 'mar',
      name: 'Marokkó',
    },
    '508': {
      id: 508,
      alpha2: 'mz',
      alpha3: 'moz',
      name: 'Mozambik',
    },
    '512': {
      id: 512,
      alpha2: 'om',
      alpha3: 'omn',
      name: 'Omán',
    },
    '516': {
      id: 516,
      alpha2: 'na',
      alpha3: 'nam',
      name: 'Namíbia',
    },
    '520': {
      id: 520,
      alpha2: 'nr',
      alpha3: 'nru',
      name: 'Nauru',
    },
    '524': {
      id: 524,
      alpha2: 'np',
      alpha3: 'npl',
      name: 'Nepál',
    },
    '528': {
      id: 528,
      alpha2: 'nl',
      alpha3: 'nld',
      name: 'Hollandia',
    },
    '548': {
      id: 548,
      alpha2: 'vu',
      alpha3: 'vut',
      name: 'Vanuatu',
    },
    '554': {
      id: 554,
      alpha2: 'nz',
      alpha3: 'nzl',
      name: 'Új-Zéland',
    },
    '558': {
      id: 558,
      alpha2: 'ni',
      alpha3: 'nic',
      name: 'Nicaragua',
    },
    '562': {
      id: 562,
      alpha2: 'ne',
      alpha3: 'ner',
      name: 'Niger',
    },
    '566': {
      id: 566,
      alpha2: 'ng',
      alpha3: 'nga',
      name: 'Nigéria',
    },
    '578': {
      id: 578,
      alpha2: 'no',
      alpha3: 'nor',
      name: 'Norvégia',
    },
    '583': {
      id: 583,
      alpha2: 'fm',
      alpha3: 'fsm',
      name: 'Mikronézia',
    },
    '584': {
      id: 584,
      alpha2: 'mh',
      alpha3: 'mhl',
      name: 'Marshall-szigetek',
    },
    '585': {
      id: 585,
      alpha2: 'pw',
      alpha3: 'plw',
      name: 'Palau',
    },
    '586': {
      id: 586,
      alpha2: 'pk',
      alpha3: 'pak',
      name: 'Pakisztán',
    },
    '591': {
      id: 591,
      alpha2: 'pa',
      alpha3: 'pan',
      name: 'Panama',
    },
    '598': {
      id: 598,
      alpha2: 'pg',
      alpha3: 'png',
      name: 'Pápua Új-Guinea',
    },
    '600': {
      id: 600,
      alpha2: 'py',
      alpha3: 'pry',
      name: 'Paraguay',
    },
    '604': {
      id: 604,
      alpha2: 'pe',
      alpha3: 'per',
      name: 'Peru',
    },
    '608': {
      id: 608,
      alpha2: 'ph',
      alpha3: 'phl',
      name: 'Fülöp-szigetek',
    },
    '616': {
      id: 616,
      alpha2: 'pl',
      alpha3: 'pol',
      name: 'Lengyelország',
    },
    '620': {
      id: 620,
      alpha2: 'pt',
      alpha3: 'prt',
      name: 'Portugália',
    },
    '624': {
      id: 624,
      alpha2: 'gw',
      alpha3: 'gnb',
      name: 'Bissau-Guinea',
    },
    '626': {
      id: 626,
      alpha2: 'tl',
      alpha3: 'tls',
      name: 'Kelet-Timor',
    },
    '634': {
      id: 634,
      alpha2: 'qa',
      alpha3: 'qat',
      name: 'Katar',
    },
    '642': {
      id: 642,
      alpha2: 'ro',
      alpha3: 'rou',
      name: 'Románia',
    },
    '643': {
      id: 643,
      alpha2: 'ru',
      alpha3: 'rus',
      name: 'Oroszország',
    },
    '646': {
      id: 646,
      alpha2: 'rw',
      alpha3: 'rwa',
      name: 'Ruanda',
    },
    '659': {
      id: 659,
      alpha2: 'kn',
      alpha3: 'kna',
      name: 'Saint Kitts és Nevis',
    },
    '662': {
      id: 662,
      alpha2: 'lc',
      alpha3: 'lca',
      name: 'Saint Lucia',
    },
    '670': {
      id: 670,
      alpha2: 'vc',
      alpha3: 'vct',
      name: 'Saint Vincent és a Grenadine-szigetek',
    },
    '674': {
      id: 674,
      alpha2: 'sm',
      alpha3: 'smr',
      name: 'San Marino',
    },
    '678': {
      id: 678,
      alpha2: 'st',
      alpha3: 'stp',
      name: 'São Tomé és Príncipe',
    },
    '682': {
      id: 682,
      alpha2: 'sa',
      alpha3: 'sau',
      name: 'Szaúd-Arábia',
    },
    '686': {
      id: 686,
      alpha2: 'sn',
      alpha3: 'sen',
      name: 'Szenegál',
    },
    '688': {
      id: 688,
      alpha2: 'rs',
      alpha3: 'srb',
      name: 'Szerbia',
    },
    '690': {
      id: 690,
      alpha2: 'sc',
      alpha3: 'syc',
      name: 'Seychelle-szigetek',
    },
    '694': {
      id: 694,
      alpha2: 'sl',
      alpha3: 'sle',
      name: 'Sierra Leone',
    },
    '702': {
      id: 702,
      alpha2: 'sg',
      alpha3: 'sgp',
      name: 'Szingapúr',
    },
    '703': {
      id: 703,
      alpha2: 'sk',
      alpha3: 'svk',
      name: 'Szlovákia',
    },
    '704': {
      id: 704,
      alpha2: 'vn',
      alpha3: 'vnm',
      name: 'Vietnám',
    },
    '705': {
      id: 705,
      alpha2: 'si',
      alpha3: 'svn',
      name: 'Szlovénia',
    },
    '706': {
      id: 706,
      alpha2: 'so',
      alpha3: 'som',
      name: 'Szomália',
    },
    '710': {
      id: 710,
      alpha2: 'za',
      alpha3: 'zaf',
      name: 'Dél-afrikai Köztársaság',
    },
    '716': {
      id: 716,
      alpha2: 'zw',
      alpha3: 'zwe',
      name: 'Zimbabwe',
    },
    '724': {
      id: 724,
      alpha2: 'es',
      alpha3: 'esp',
      name: 'Spanyolország',
    },
    '728': {
      id: 728,
      alpha2: 'ss',
      alpha3: 'ssd',
      name: 'Dél-Szudán',
    },
    '729': {
      id: 729,
      alpha2: 'sd',
      alpha3: 'sdn',
      name: 'Szudán',
    },
    '740': {
      id: 740,
      alpha2: 'sr',
      alpha3: 'sur',
      name: 'Suriname',
    },
    '748': {
      id: 748,
      alpha2: 'sz',
      alpha3: 'swz',
      name: 'Szváziföld',
    },
    '752': {
      id: 752,
      alpha2: 'se',
      alpha3: 'swe',
      name: 'Svédország',
    },
    '756': {
      id: 756,
      alpha2: 'ch',
      alpha3: 'che',
      name: 'Svájc',
    },
    '760': {
      id: 760,
      alpha2: 'sy',
      alpha3: 'syr',
      name: 'Szíria',
    },
    '762': {
      id: 762,
      alpha2: 'tj',
      alpha3: 'tjk',
      name: 'Tádzsikisztán',
    },
    '764': {
      id: 764,
      alpha2: 'th',
      alpha3: 'tha',
      name: 'Thaiföld',
    },
    '768': {
      id: 768,
      alpha2: 'tg',
      alpha3: 'tgo',
      name: 'Togo',
    },
    '776': {
      id: 776,
      alpha2: 'to',
      alpha3: 'ton',
      name: 'Tonga',
    },
    '780': {
      id: 780,
      alpha2: 'tt',
      alpha3: 'tto',
      name: 'Trinidad és Tobago',
    },
    '784': {
      id: 784,
      alpha2: 'ae',
      alpha3: 'are',
      name: 'Egyesült Arab Emírségek',
    },
    '788': {
      id: 788,
      alpha2: 'tn',
      alpha3: 'tun',
      name: 'Tunézia',
    },
    '792': {
      id: 792,
      alpha2: 'tr',
      alpha3: 'tur',
      name: 'Törökország',
    },
    '795': {
      id: 795,
      alpha2: 'tm',
      alpha3: 'tkm',
      name: 'Türkmenisztán',
    },
    '798': {
      id: 798,
      alpha2: 'tv',
      alpha3: 'tuv',
      name: 'Tuvalu',
    },
    '800': {
      id: 800,
      alpha2: 'ug',
      alpha3: 'uga',
      name: 'Uganda',
    },
    '804': {
      id: 804,
      alpha2: 'ua',
      alpha3: 'ukr',
      name: 'Ukrajna',
    },
    '807': {
      id: 807,
      alpha2: 'mk',
      alpha3: 'mkd',
      name: 'Észak-Macedónia',
    },
    '818': {
      id: 818,
      alpha2: 'eg',
      alpha3: 'egy',
      name: 'Egyiptom',
    },
    '826': {
      id: 826,
      alpha2: 'gb',
      alpha3: 'gbr',
      name: 'Egyesült Királyság',
    },
    '834': {
      id: 834,
      alpha2: 'tz',
      alpha3: 'tza',
      name: 'Tanzánia',
    },
    '840': {
      id: 840,
      alpha2: 'us',
      alpha3: 'usa',
      name: 'Amerikai Egyesült Államok',
    },
    '854': {
      id: 854,
      alpha2: 'bf',
      alpha3: 'bfa',
      name: 'Burkina Faso',
    },
    '858': {
      id: 858,
      alpha2: 'uy',
      alpha3: 'ury',
      name: 'Uruguay',
    },
    '860': {
      id: 860,
      alpha2: 'uz',
      alpha3: 'uzb',
      name: 'Üzbegisztán',
    },
    '862': {
      id: 862,
      alpha2: 've',
      alpha3: 'ven',
      name: 'Venezuela',
    },
    '882': {
      id: 882,
      alpha2: 'ws',
      alpha3: 'wsm',
      name: 'Szamoa',
    },
    '887': {
      id: 887,
      alpha2: 'ye',
      alpha3: 'yem',
      name: 'Jemen',
    },
    '894': {
      id: 894,
      alpha2: 'zm',
      alpha3: 'zmb',
      name: 'Zambia',
    },
  },
  en: {
    '4': {
      id: 4,
      alpha2: 'af',
      alpha3: 'afg',
      name: 'Afghanistan',
    },
    '8': {
      id: 8,
      alpha2: 'al',
      alpha3: 'alb',
      name: 'Albania',
    },
    '12': {
      id: 12,
      alpha2: 'dz',
      alpha3: 'dza',
      name: 'Algeria',
    },
    '20': {
      id: 20,
      alpha2: 'ad',
      alpha3: 'and',
      name: 'Andorra',
    },
    '24': {
      id: 24,
      alpha2: 'ao',
      alpha3: 'ago',
      name: 'Angola',
    },
    '28': {
      id: 28,
      alpha2: 'ag',
      alpha3: 'atg',
      name: 'Antigua and Barbuda',
    },
    '31': {
      id: 31,
      alpha2: 'az',
      alpha3: 'aze',
      name: 'Azerbaijan',
    },
    '32': {
      id: 32,
      alpha2: 'ar',
      alpha3: 'arg',
      name: 'Argentina',
    },
    '36': {
      id: 36,
      alpha2: 'au',
      alpha3: 'aus',
      name: 'Australia',
    },
    '40': {
      id: 40,
      alpha2: 'at',
      alpha3: 'aut',
      name: 'Austria',
    },
    '44': {
      id: 44,
      alpha2: 'bs',
      alpha3: 'bhs',
      name: 'Bahamas',
    },
    '48': {
      id: 48,
      alpha2: 'bh',
      alpha3: 'bhr',
      name: 'Bahrain',
    },
    '50': {
      id: 50,
      alpha2: 'bd',
      alpha3: 'bgd',
      name: 'Bangladesh',
    },
    '51': {
      id: 51,
      alpha2: 'am',
      alpha3: 'arm',
      name: 'Armenia',
    },
    '52': {
      id: 52,
      alpha2: 'bb',
      alpha3: 'brb',
      name: 'Barbados',
    },
    '56': {
      id: 56,
      alpha2: 'be',
      alpha3: 'bel',
      name: 'Belgium',
    },
    '64': {
      id: 64,
      alpha2: 'bt',
      alpha3: 'btn',
      name: 'Bhutan',
    },
    '68': {
      id: 68,
      alpha2: 'bo',
      alpha3: 'bol',
      name: 'Bolivia, Plurinational State of',
    },
    '70': {
      id: 70,
      alpha2: 'ba',
      alpha3: 'bih',
      name: 'Bosnia and Herzegovina',
    },
    '72': {
      id: 72,
      alpha2: 'bw',
      alpha3: 'bwa',
      name: 'Botswana',
    },
    '76': {
      id: 76,
      alpha2: 'br',
      alpha3: 'bra',
      name: 'Brazil',
    },
    '84': {
      id: 84,
      alpha2: 'bz',
      alpha3: 'blz',
      name: 'Belize',
    },
    '90': {
      id: 90,
      alpha2: 'sb',
      alpha3: 'slb',
      name: 'Solomon Islands',
    },
    '96': {
      id: 96,
      alpha2: 'bn',
      alpha3: 'brn',
      name: 'Brunei Darussalam',
    },
    '100': {
      id: 100,
      alpha2: 'bg',
      alpha3: 'bgr',
      name: 'Bulgaria',
    },
    '104': {
      id: 104,
      alpha2: 'mm',
      alpha3: 'mmr',
      name: 'Myanmar',
    },
    '108': {
      id: 108,
      alpha2: 'bi',
      alpha3: 'bdi',
      name: 'Burundi',
    },
    '112': {
      id: 112,
      alpha2: 'by',
      alpha3: 'blr',
      name: 'Belarus',
    },
    '116': {
      id: 116,
      alpha2: 'kh',
      alpha3: 'khm',
      name: 'Cambodia',
    },
    '120': {
      id: 120,
      alpha2: 'cm',
      alpha3: 'cmr',
      name: 'Cameroon',
    },
    '124': {
      id: 124,
      alpha2: 'ca',
      alpha3: 'can',
      name: 'Canada',
    },
    '132': {
      id: 132,
      alpha2: 'cv',
      alpha3: 'cpv',
      name: 'Cabo Verde',
    },
    '140': {
      id: 140,
      alpha2: 'cf',
      alpha3: 'caf',
      name: 'Central African Republic',
    },
    '144': {
      id: 144,
      alpha2: 'lk',
      alpha3: 'lka',
      name: 'Sri Lanka',
    },
    '148': {
      id: 148,
      alpha2: 'td',
      alpha3: 'tcd',
      name: 'Chad',
    },
    '152': {
      id: 152,
      alpha2: 'cl',
      alpha3: 'chl',
      name: 'Chile',
    },
    '156': {
      id: 156,
      alpha2: 'cn',
      alpha3: 'chn',
      name: 'China',
    },
    '170': {
      id: 170,
      alpha2: 'co',
      alpha3: 'col',
      name: 'Colombia',
    },
    '174': {
      id: 174,
      alpha2: 'km',
      alpha3: 'com',
      name: 'Comoros',
    },
    '178': {
      id: 178,
      alpha2: 'cg',
      alpha3: 'cog',
      name: 'Congo',
    },
    '180': {
      id: 180,
      alpha2: 'cd',
      alpha3: 'cod',
      name: 'Congo, Democratic Republic of the',
    },
    '188': {
      id: 188,
      alpha2: 'cr',
      alpha3: 'cri',
      name: 'Costa Rica',
    },
    '191': {
      id: 191,
      alpha2: 'hr',
      alpha3: 'hrv',
      name: 'Croatia',
    },
    '192': {
      id: 192,
      alpha2: 'cu',
      alpha3: 'cub',
      name: 'Cuba',
    },
    '196': {
      id: 196,
      alpha2: 'cy',
      alpha3: 'cyp',
      name: 'Cyprus',
    },
    '203': {
      id: 203,
      alpha2: 'cz',
      alpha3: 'cze',
      name: 'Czechia',
    },
    '204': {
      id: 204,
      alpha2: 'bj',
      alpha3: 'ben',
      name: 'Benin',
    },
    '208': {
      id: 208,
      alpha2: 'dk',
      alpha3: 'dnk',
      name: 'Denmark',
    },
    '212': {
      id: 212,
      alpha2: 'dm',
      alpha3: 'dma',
      name: 'Dominica',
    },
    '214': {
      id: 214,
      alpha2: 'do',
      alpha3: 'dom',
      name: 'Dominican Republic',
    },
    '218': {
      id: 218,
      alpha2: 'ec',
      alpha3: 'ecu',
      name: 'Ecuador',
    },
    '222': {
      id: 222,
      alpha2: 'sv',
      alpha3: 'slv',
      name: 'El Salvador',
    },
    '226': {
      id: 226,
      alpha2: 'gq',
      alpha3: 'gnq',
      name: 'Equatorial Guinea',
    },
    '231': {
      id: 231,
      alpha2: 'et',
      alpha3: 'eth',
      name: 'Ethiopia',
    },
    '232': {
      id: 232,
      alpha2: 'er',
      alpha3: 'eri',
      name: 'Eritrea',
    },
    '233': {
      id: 233,
      alpha2: 'ee',
      alpha3: 'est',
      name: 'Estonia',
    },
    '242': {
      id: 242,
      alpha2: 'fj',
      alpha3: 'fji',
      name: 'Fiji',
    },
    '246': {
      id: 246,
      alpha2: 'fi',
      alpha3: 'fin',
      name: 'Finland',
    },
    '250': {
      id: 250,
      alpha2: 'fr',
      alpha3: 'fra',
      name: 'France',
    },
    '262': {
      id: 262,
      alpha2: 'dj',
      alpha3: 'dji',
      name: 'Djibouti',
    },
    '266': {
      id: 266,
      alpha2: 'ga',
      alpha3: 'gab',
      name: 'Gabon',
    },
    '268': {
      id: 268,
      alpha2: 'ge',
      alpha3: 'geo',
      name: 'Georgia',
    },
    '270': {
      id: 270,
      alpha2: 'gm',
      alpha3: 'gmb',
      name: 'Gambia',
    },
    '276': {
      id: 276,
      alpha2: 'de',
      alpha3: 'deu',
      name: 'Germany',
    },
    '288': {
      id: 288,
      alpha2: 'gh',
      alpha3: 'gha',
      name: 'Ghana',
    },
    '296': {
      id: 296,
      alpha2: 'ki',
      alpha3: 'kir',
      name: 'Kiribati',
    },
    '300': {
      id: 300,
      alpha2: 'gr',
      alpha3: 'grc',
      name: 'Greece',
    },
    '308': {
      id: 308,
      alpha2: 'gd',
      alpha3: 'grd',
      name: 'Grenada',
    },
    '320': {
      id: 320,
      alpha2: 'gt',
      alpha3: 'gtm',
      name: 'Guatemala',
    },
    '324': {
      id: 324,
      alpha2: 'gn',
      alpha3: 'gin',
      name: 'Guinea',
    },
    '328': {
      id: 328,
      alpha2: 'gy',
      alpha3: 'guy',
      name: 'Guyana',
    },
    '332': {
      id: 332,
      alpha2: 'ht',
      alpha3: 'hti',
      name: 'Haiti',
    },
    '340': {
      id: 340,
      alpha2: 'hn',
      alpha3: 'hnd',
      name: 'Honduras',
    },
    '348': {
      id: 348,
      alpha2: 'hu',
      alpha3: 'hun',
      name: 'Hungary',
    },
    '352': {
      id: 352,
      alpha2: 'is',
      alpha3: 'isl',
      name: 'Iceland',
    },
    '356': {
      id: 356,
      alpha2: 'in',
      alpha3: 'ind',
      name: 'India',
    },
    '360': {
      id: 360,
      alpha2: 'id',
      alpha3: 'idn',
      name: 'Indonesia',
    },
    '364': {
      id: 364,
      alpha2: 'ir',
      alpha3: 'irn',
      name: 'Iran, Islamic Republic of',
    },
    '368': {
      id: 368,
      alpha2: 'iq',
      alpha3: 'irq',
      name: 'Iraq',
    },
    '372': {
      id: 372,
      alpha2: 'ie',
      alpha3: 'irl',
      name: 'Ireland',
    },
    '376': {
      id: 376,
      alpha2: 'il',
      alpha3: 'isr',
      name: 'Israel',
    },
    '380': {
      id: 380,
      alpha2: 'it',
      alpha3: 'ita',
      name: 'Italy',
    },
    '384': {
      id: 384,
      alpha2: 'ci',
      alpha3: 'civ',
      name: "Côte d'Ivoire",
    },
    '388': {
      id: 388,
      alpha2: 'jm',
      alpha3: 'jam',
      name: 'Jamaica',
    },
    '392': {
      id: 392,
      alpha2: 'jp',
      alpha3: 'jpn',
      name: 'Japan',
    },
    '398': {
      id: 398,
      alpha2: 'kz',
      alpha3: 'kaz',
      name: 'Kazakhstan',
    },
    '400': {
      id: 400,
      alpha2: 'jo',
      alpha3: 'jor',
      name: 'Jordan',
    },
    '404': {
      id: 404,
      alpha2: 'ke',
      alpha3: 'ken',
      name: 'Kenya',
    },
    '408': {
      id: 408,
      alpha2: 'kp',
      alpha3: 'prk',
      name: "Korea, Democratic People's Republic of",
    },
    '410': {
      id: 410,
      alpha2: 'kr',
      alpha3: 'kor',
      name: 'Korea, Republic of',
    },
    '414': {
      id: 414,
      alpha2: 'kw',
      alpha3: 'kwt',
      name: 'Kuwait',
    },
    '417': {
      id: 417,
      alpha2: 'kg',
      alpha3: 'kgz',
      name: 'Kyrgyzstan',
    },
    '418': {
      id: 418,
      alpha2: 'la',
      alpha3: 'lao',
      name: "Lao People's Democratic Republic",
    },
    '422': {
      id: 422,
      alpha2: 'lb',
      alpha3: 'lbn',
      name: 'Lebanon',
    },
    '426': {
      id: 426,
      alpha2: 'ls',
      alpha3: 'lso',
      name: 'Lesotho',
    },
    '428': {
      id: 428,
      alpha2: 'lv',
      alpha3: 'lva',
      name: 'Latvia',
    },
    '430': {
      id: 430,
      alpha2: 'lr',
      alpha3: 'lbr',
      name: 'Liberia',
    },
    '434': {
      id: 434,
      alpha2: 'ly',
      alpha3: 'lby',
      name: 'Libya',
    },
    '438': {
      id: 438,
      alpha2: 'li',
      alpha3: 'lie',
      name: 'Liechtenstein',
    },
    '440': {
      id: 440,
      alpha2: 'lt',
      alpha3: 'ltu',
      name: 'Lithuania',
    },
    '442': {
      id: 442,
      alpha2: 'lu',
      alpha3: 'lux',
      name: 'Luxembourg',
    },
    '450': {
      id: 450,
      alpha2: 'mg',
      alpha3: 'mdg',
      name: 'Madagascar',
    },
    '454': {
      id: 454,
      alpha2: 'mw',
      alpha3: 'mwi',
      name: 'Malawi',
    },
    '458': {
      id: 458,
      alpha2: 'my',
      alpha3: 'mys',
      name: 'Malaysia',
    },
    '462': {
      id: 462,
      alpha2: 'mv',
      alpha3: 'mdv',
      name: 'Maldives',
    },
    '466': {
      id: 466,
      alpha2: 'ml',
      alpha3: 'mli',
      name: 'Mali',
    },
    '470': {
      id: 470,
      alpha2: 'mt',
      alpha3: 'mlt',
      name: 'Malta',
    },
    '478': {
      id: 478,
      alpha2: 'mr',
      alpha3: 'mrt',
      name: 'Mauritania',
    },
    '480': {
      id: 480,
      alpha2: 'mu',
      alpha3: 'mus',
      name: 'Mauritius',
    },
    '484': {
      id: 484,
      alpha2: 'mx',
      alpha3: 'mex',
      name: 'Mexico',
    },
    '492': {
      id: 492,
      alpha2: 'mc',
      alpha3: 'mco',
      name: 'Monaco',
    },
    '496': {
      id: 496,
      alpha2: 'mn',
      alpha3: 'mng',
      name: 'Mongolia',
    },
    '498': {
      id: 498,
      alpha2: 'md',
      alpha3: 'mda',
      name: 'Moldova, Republic of',
    },
    '499': {
      id: 499,
      alpha2: 'me',
      alpha3: 'mne',
      name: 'Montenegro',
    },
    '504': {
      id: 504,
      alpha2: 'ma',
      alpha3: 'mar',
      name: 'Morocco',
    },
    '508': {
      id: 508,
      alpha2: 'mz',
      alpha3: 'moz',
      name: 'Mozambique',
    },
    '512': {
      id: 512,
      alpha2: 'om',
      alpha3: 'omn',
      name: 'Oman',
    },
    '516': {
      id: 516,
      alpha2: 'na',
      alpha3: 'nam',
      name: 'Namibia',
    },
    '520': {
      id: 520,
      alpha2: 'nr',
      alpha3: 'nru',
      name: 'Nauru',
    },
    '524': {
      id: 524,
      alpha2: 'np',
      alpha3: 'npl',
      name: 'Nepal',
    },
    '528': {
      id: 528,
      alpha2: 'nl',
      alpha3: 'nld',
      name: 'Netherlands',
    },
    '548': {
      id: 548,
      alpha2: 'vu',
      alpha3: 'vut',
      name: 'Vanuatu',
    },
    '554': {
      id: 554,
      alpha2: 'nz',
      alpha3: 'nzl',
      name: 'New Zealand',
    },
    '558': {
      id: 558,
      alpha2: 'ni',
      alpha3: 'nic',
      name: 'Nicaragua',
    },
    '562': {
      id: 562,
      alpha2: 'ne',
      alpha3: 'ner',
      name: 'Niger',
    },
    '566': {
      id: 566,
      alpha2: 'ng',
      alpha3: 'nga',
      name: 'Nigeria',
    },
    '578': {
      id: 578,
      alpha2: 'no',
      alpha3: 'nor',
      name: 'Norway',
    },
    '583': {
      id: 583,
      alpha2: 'fm',
      alpha3: 'fsm',
      name: 'Micronesia, Federated States of',
    },
    '584': {
      id: 584,
      alpha2: 'mh',
      alpha3: 'mhl',
      name: 'Marshall Islands',
    },
    '585': {
      id: 585,
      alpha2: 'pw',
      alpha3: 'plw',
      name: 'Palau',
    },
    '586': {
      id: 586,
      alpha2: 'pk',
      alpha3: 'pak',
      name: 'Pakistan',
    },
    '591': {
      id: 591,
      alpha2: 'pa',
      alpha3: 'pan',
      name: 'Panama',
    },
    '598': {
      id: 598,
      alpha2: 'pg',
      alpha3: 'png',
      name: 'Papua New Guinea',
    },
    '600': {
      id: 600,
      alpha2: 'py',
      alpha3: 'pry',
      name: 'Paraguay',
    },
    '604': {
      id: 604,
      alpha2: 'pe',
      alpha3: 'per',
      name: 'Peru',
    },
    '608': {
      id: 608,
      alpha2: 'ph',
      alpha3: 'phl',
      name: 'Philippines',
    },
    '616': {
      id: 616,
      alpha2: 'pl',
      alpha3: 'pol',
      name: 'Poland',
    },
    '620': {
      id: 620,
      alpha2: 'pt',
      alpha3: 'prt',
      name: 'Portugal',
    },
    '624': {
      id: 624,
      alpha2: 'gw',
      alpha3: 'gnb',
      name: 'Guinea-Bissau',
    },
    '626': {
      id: 626,
      alpha2: 'tl',
      alpha3: 'tls',
      name: 'Timor-Leste',
    },
    '634': {
      id: 634,
      alpha2: 'qa',
      alpha3: 'qat',
      name: 'Qatar',
    },
    '642': {
      id: 642,
      alpha2: 'ro',
      alpha3: 'rou',
      name: 'Romania',
    },
    '643': {
      id: 643,
      alpha2: 'ru',
      alpha3: 'rus',
      name: 'Russian Federation',
    },
    '646': {
      id: 646,
      alpha2: 'rw',
      alpha3: 'rwa',
      name: 'Rwanda',
    },
    '659': {
      id: 659,
      alpha2: 'kn',
      alpha3: 'kna',
      name: 'Saint Kitts and Nevis',
    },
    '662': {
      id: 662,
      alpha2: 'lc',
      alpha3: 'lca',
      name: 'Saint Lucia',
    },
    '670': {
      id: 670,
      alpha2: 'vc',
      alpha3: 'vct',
      name: 'Saint Vincent and the Grenadines',
    },
    '674': {
      id: 674,
      alpha2: 'sm',
      alpha3: 'smr',
      name: 'San Marino',
    },
    '678': {
      id: 678,
      alpha2: 'st',
      alpha3: 'stp',
      name: 'Sao Tome and Principe',
    },
    '682': {
      id: 682,
      alpha2: 'sa',
      alpha3: 'sau',
      name: 'Saudi Arabia',
    },
    '686': {
      id: 686,
      alpha2: 'sn',
      alpha3: 'sen',
      name: 'Senegal',
    },
    '688': {
      id: 688,
      alpha2: 'rs',
      alpha3: 'srb',
      name: 'Serbia',
    },
    '690': {
      id: 690,
      alpha2: 'sc',
      alpha3: 'syc',
      name: 'Seychelles',
    },
    '694': {
      id: 694,
      alpha2: 'sl',
      alpha3: 'sle',
      name: 'Sierra Leone',
    },
    '702': {
      id: 702,
      alpha2: 'sg',
      alpha3: 'sgp',
      name: 'Singapore',
    },
    '703': {
      id: 703,
      alpha2: 'sk',
      alpha3: 'svk',
      name: 'Slovakia',
    },
    '704': {
      id: 704,
      alpha2: 'vn',
      alpha3: 'vnm',
      name: 'Viet Nam',
    },
    '705': {
      id: 705,
      alpha2: 'si',
      alpha3: 'svn',
      name: 'Slovenia',
    },
    '706': {
      id: 706,
      alpha2: 'so',
      alpha3: 'som',
      name: 'Somalia',
    },
    '710': {
      id: 710,
      alpha2: 'za',
      alpha3: 'zaf',
      name: 'South Africa',
    },
    '716': {
      id: 716,
      alpha2: 'zw',
      alpha3: 'zwe',
      name: 'Zimbabwe',
    },
    '724': {
      id: 724,
      alpha2: 'es',
      alpha3: 'esp',
      name: 'Spain',
    },
    '728': {
      id: 728,
      alpha2: 'ss',
      alpha3: 'ssd',
      name: 'South Sudan',
    },
    '729': {
      id: 729,
      alpha2: 'sd',
      alpha3: 'sdn',
      name: 'Sudan',
    },
    '740': {
      id: 740,
      alpha2: 'sr',
      alpha3: 'sur',
      name: 'Suriname',
    },
    '748': {
      id: 748,
      alpha2: 'sz',
      alpha3: 'swz',
      name: 'Eswatini',
    },
    '752': {
      id: 752,
      alpha2: 'se',
      alpha3: 'swe',
      name: 'Sweden',
    },
    '756': {
      id: 756,
      alpha2: 'ch',
      alpha3: 'che',
      name: 'Switzerland',
    },
    '760': {
      id: 760,
      alpha2: 'sy',
      alpha3: 'syr',
      name: 'Syrian Arab Republic',
    },
    '762': {
      id: 762,
      alpha2: 'tj',
      alpha3: 'tjk',
      name: 'Tajikistan',
    },
    '764': {
      id: 764,
      alpha2: 'th',
      alpha3: 'tha',
      name: 'Thailand',
    },
    '768': {
      id: 768,
      alpha2: 'tg',
      alpha3: 'tgo',
      name: 'Togo',
    },
    '776': {
      id: 776,
      alpha2: 'to',
      alpha3: 'ton',
      name: 'Tonga',
    },
    '780': {
      id: 780,
      alpha2: 'tt',
      alpha3: 'tto',
      name: 'Trinidad and Tobago',
    },
    '784': {
      id: 784,
      alpha2: 'ae',
      alpha3: 'are',
      name: 'United Arab Emirates',
    },
    '788': {
      id: 788,
      alpha2: 'tn',
      alpha3: 'tun',
      name: 'Tunisia',
    },
    '792': {
      id: 792,
      alpha2: 'tr',
      alpha3: 'tur',
      name: 'Türkiye',
    },
    '795': {
      id: 795,
      alpha2: 'tm',
      alpha3: 'tkm',
      name: 'Turkmenistan',
    },
    '798': {
      id: 798,
      alpha2: 'tv',
      alpha3: 'tuv',
      name: 'Tuvalu',
    },
    '800': {
      id: 800,
      alpha2: 'ug',
      alpha3: 'uga',
      name: 'Uganda',
    },
    '804': {
      id: 804,
      alpha2: 'ua',
      alpha3: 'ukr',
      name: 'Ukraine',
    },
    '807': {
      id: 807,
      alpha2: 'mk',
      alpha3: 'mkd',
      name: 'North Macedonia',
    },
    '818': {
      id: 818,
      alpha2: 'eg',
      alpha3: 'egy',
      name: 'Egypt',
    },
    '826': {
      id: 826,
      alpha2: 'gb',
      alpha3: 'gbr',
      name: 'United Kingdom of Great Britain and Northern Ireland',
    },
    '834': {
      id: 834,
      alpha2: 'tz',
      alpha3: 'tza',
      name: 'Tanzania, United Republic of',
    },
    '840': {
      id: 840,
      alpha2: 'us',
      alpha3: 'usa',
      name: 'United States of America',
    },
    '854': {
      id: 854,
      alpha2: 'bf',
      alpha3: 'bfa',
      name: 'Burkina Faso',
    },
    '858': {
      id: 858,
      alpha2: 'uy',
      alpha3: 'ury',
      name: 'Uruguay',
    },
    '860': {
      id: 860,
      alpha2: 'uz',
      alpha3: 'uzb',
      name: 'Uzbekistan',
    },
    '862': {
      id: 862,
      alpha2: 've',
      alpha3: 'ven',
      name: 'Venezuela, Bolivarian Republic of',
    },
    '882': {
      id: 882,
      alpha2: 'ws',
      alpha3: 'wsm',
      name: 'Samoa',
    },
    '887': {
      id: 887,
      alpha2: 'ye',
      alpha3: 'yem',
      name: 'Yemen',
    },
    '894': {
      id: 894,
      alpha2: 'zm',
      alpha3: 'zmb',
      name: 'Zambia',
    },
  },
}
